import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
const btns = [
  {
    name: "Shop Now",
    color: "#494D58",
    aos: "fade-right",
  },
  {
    name: "New Activation",
    color: "#2B90ED",
    aos: "fade-down",
  },
  {
    name: "Sales/Help",
    color: "#5D936D",
    aos: "fade-up",
  },
  {
    name: "New Recharge",
    color: "#F26749",
    aos: "fade-left",
  },
];
const Buttons = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return (
    <div>
      <div className="mx-8 lg:mx-12 grid md:grid-cols-4 grid-cols-2 xl:gap-12 lg:gap-10 sm:gap-6 gap-2 sm:py-10 py-6">
        {btns.map((btn, index) => {
          return (
            <button
              className={`text-white  xl:px-12 lg:px-6 sm:px-2 xl:py-10 lg:py-6 py-4 rounded-md xl:text-2xl lg:text-xl dm:text-lg text-md tracking-wide font-bold`}
              style={{ backgroundColor: `${btn.color}` }}
              data-aos={btn.aos}
            >
              {btn.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Buttons;
